import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=38a53354"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a53354')) {
      api.createRecord('38a53354', component.options)
    } else {
      api.reload('38a53354', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=38a53354", function () {
      api.rerender('38a53354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Delete.vue"
export default component.exports